export default ({ next, auth, store, routerNext }) => {
  if (!auth.getAuth()) {
    return routerNext({
      name: 'Login'
    })
  }
  const data = auth.getAuthDecode()
  if (data && ((data.exp - 1800) * 1000) <= new Date().getTime()) {
    return store.dispatch('Style/tokenExpire', () => routerNext({
      name: 'Login'
    }))
  }
  return next()
}
